/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PromoTokenOpenLinkResponse
 */
export interface PromoTokenOpenLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof PromoTokenOpenLinkResponse
     */
    redirectPath: string;
}

/**
 * Check if a given object implements the PromoTokenOpenLinkResponse interface.
 */
export function instanceOfPromoTokenOpenLinkResponse(value: object): value is PromoTokenOpenLinkResponse {
    if (!('redirectPath' in value) || value['redirectPath'] === undefined) return false;
    return true;
}

export function PromoTokenOpenLinkResponseFromJSON(json: any): PromoTokenOpenLinkResponse {
    return PromoTokenOpenLinkResponseFromJSONTyped(json, false);
}

export function PromoTokenOpenLinkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenOpenLinkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectPath': json['redirectPath'],
    };
}

export function PromoTokenOpenLinkResponseToJSON(json: any): PromoTokenOpenLinkResponse {
    return PromoTokenOpenLinkResponseToJSONTyped(json, false);
}

export function PromoTokenOpenLinkResponseToJSONTyped(value?: PromoTokenOpenLinkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectPath': value['redirectPath'],
    };
}

